// AUTO-GENERATED by scripts/codegen/generate-icon-sprite.ts — do not edit by hand.
// Content hash of the generated sprite. Changes only when the sprite changes
// (icons added/removed/edited or EXCLUDED_ICONS changed). Regenerated by the
// `prebuild` script on every build, so production always serves a fresh value
// even if this committed copy is momentarily stale.
export const SPRITE_VERSION = '551f032f'
